import React from "react";

/**
 * Official MAKEBA logo - uses the vector artwork extracted from the brand's own Branding Board.
 * `variant="dark"` renders the white/negative version for dark backgrounds.
 */
const MakebaLogo = ({ variant = "light", tagline = true, className = "", height }) => {
  const src = variant === "dark" ? "/brand/makeba-logo-dark.png" : "/brand/makeba-logo.png";
  // If a className drives sizing (e.g. "h-6 lg:h-9"), don't override with inline height.
  const style = height != null
    ? { height, width: "auto", display: "block", objectFit: "contain" }
    : { width: "auto", display: "block", objectFit: "contain" };
  return (
    <img
      src={src}
      alt="MAKEBA Design & Prints"
      className={className}
      style={style}
      draggable={false}
    />
  );
};

export default MakebaLogo;
